// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { DeleteAiAgentConfigsCancelByIdParam, BaseResponseVoid } from '../../../types';

/**
 * 取消授权
 *
 * @export
 * @tags Coze智能体
 * @link [DELETE] /aiAgentConfigs/cancel/{id}
 * @param id
 */
export function deleteAiAgentConfigsCancelById(
    options: ApiOptions<DeleteAiAgentConfigsCancelByIdParam, never> & {
        segments: DeleteAiAgentConfigsCancelByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeleteAiAgentConfigsCancelByIdParam, never>(
        '/aiAgentConfigs/cancel/{id}',
        { ...options, method: 'delete', __$requestCalleeName: 'deleteAiAgentConfigsCancelById' }
    );
}

export const meta = [
    { tags: ['Coze智能体'], path: '/aiAgentConfigs/cancel/{id}', method: 'delete' },
];
